import { lazy } from "react";
import ScrollTop from "@/hoc/ScrollTop";

const Dashboard = lazy(() => import("@/pages/Dashboard"));
const TransactionDashboard = lazy(() =>
  import("@/pages/Dashboard/TransactionDashboard"),
);
const SalesDashboard = lazy(() => import("@/pages/Dashboard/SalesDashboard"));
const SalesDashboardMonthly = lazy(() =>
  import("@/pages/Dashboard/SalesDashboard/components/SalesDashboardMonthly"),
);
const ListEmployees = lazy(() =>
  import("@/pages/Dashboard/components/ListEmployees"),
);

const Users = lazy(() => import("@/pages/Users"));
const Employees = lazy(() => import("@/pages/Employees"));
const EmployeesOnMap = lazy(() => import("@/pages/EmployeesOnMap"));
const Profile = lazy(() => import("@/pages/Profile"));
const UserLog = lazy(() => import("@/pages/UserLog"));

const Organizations = lazy(() => import("@/pages/Organizations"));
const ServiceOrganization = lazy(() =>
  import("@/pages/Organizations/ServiceOrganization"),
);
const OrganizationsFilial = lazy(() => import("@/pages/OrganizationsFilial"));
const Departments = lazy(() => import("@/pages/Departments"));
const OrganizationStatus = lazy(() => import("@/pages/OrganizationStatus"));
const OfflineJobs = lazy(() => import("@/pages/OfflineJobs"));

const Transactions = lazy(() => import("@/pages/Transactions"));
const TransactionDebt = lazy(() =>
  import("@/pages/Transactions/components/TransactionDebt"),
);
const TransactionsDevent = lazy(() => import("@/pages/TransactionDevent"));
const TransactionHamkorbank = lazy(() =>
  import("@/pages/TransactionHamkorBank"),
);
const TransactionHamkorbankList = lazy(() =>
  import("@/pages/HamkorBank/HamkorBankTransactionTotalList"),
);
const OrdersList = lazy(() => import("@/pages/Orders"));
const Approvals = lazy(() => import("@/pages/Approvals"));
const Counterparties = lazy(() => import("@/pages/Counterparties"));

const Comings = lazy(() => import("@/pages/Storage/Comings"));
const ComingsView = lazy(() => import("@/pages/Storage/Comings/View"));
const IncomesReport = lazy(() =>
  import("@/pages/Storage/Comings/incomeReports"),
);
const IncomeReportInner = lazy(() =>
  import("@/pages/Storage/Comings/incomeReportInner"),
);
const Consumption = lazy(() => import("@/pages/Storage/Consumption"));
const ConsumptionInner = lazy(() =>
  import("@/pages/Storage/Consumption/inner"),
);
const Warehouse = lazy(() => import("@/pages/Storage/Warehouse/List"));
const InnerWarehouse = lazy(() =>
  import("@/pages/Storage/Warehouse/List/innerWarehouse"),
);
const Transfer = lazy(() => import("@/pages/Storage/Transfers"));
const TransferView = lazy(() => import("@/pages/Storage/Transfers/View"));
const Adjustments = lazy(() => import("@/pages/Storage/Adjustments"));

const Materials = lazy(() => import("@/pages/Nomenclature/Materials"));
const MaterialsImports = lazy(() =>
  import("@/pages/Nomenclature/Materials/materials-import"),
);
const MaterialsTwo = lazy(() => import("@/pages/Nomenclature/MaterialsTwo"));
const MaterialsTwoImports = lazy(() =>
  import("@/pages/Nomenclature/MaterialsTwo/materials-import"),
);
const Categories = lazy(() => import("@/pages/Nomenclature/Categories"));
const ImportCategories = lazy(() =>
  import("@/pages/Nomenclature/Categories/ImportCategories"),
);

const CategoriesExpense = lazy(() =>
  import("@/pages/Finance/CategoriesExpense"),
);
const CategoriesIncome = lazy(() => import("@/pages/Finance/CategoriesIncome"));
const TransactionsFinance = lazy(() => import("@/pages/Finance/Transactions"));
const Cashbox = lazy(() => import("@/pages/Finance/Cashbox"));
const DebtPaymentSplit = lazy(() => import("@/pages/Finance/DebtPaymentSplit"));
const FinanceTemplatesList = lazy(() =>
  import("@/pages/Finance/FinanceTemplatesList"),
);
const FinanceTemplateEdit = lazy(() =>
  import("@/pages/Finance/FinanceTemplateEdit"),
);

const PaymentTypes = lazy(() => import("@/pages/Settings/PaymentTypes"));
const ImportPaymentTypes = lazy(() =>
  import("@/pages/Settings/PaymentTypes/ImportHandbookPaymentTypes"),
);
const Units = lazy(() => import("@/pages/Settings/Units"));

const ReportDebtCredit = lazy(() => import("@/pages/Reports/reportDebtCredit"));
const ReportAct = lazy(() => import("@/pages/Reports/reportAct"));
const ReportProducts = lazy(() => import("@/pages/Reports/reportProducts"));
const ReportProductsCount = lazy(() =>
  import("@/pages/Reports/reportProductsCount"),
);

const Leads = lazy(() => import("@/pages/Leads"));
const LeadsStatus = lazy(() => import("@/pages/LeadsStatus"));
const LeadsTags = lazy(() => import("@/pages/LeadsTags"));
const LeadsStatistics = lazy(() => import("@/pages/Leads/LeadStatistics"));
const LeadCancellation = lazy(() => import("@/pages/LeadCancellation"));

const HandbookRegion = lazy(() => import("@/pages/Handbook/Region"));
const HandbookCountry = lazy(() => import("@/pages/Handbook/Country"));
const HandbookDistrict = lazy(() => import("@/pages/Handbook/District"));

const Targets = lazy(() => import("@/pages/Targets"));

const Service = lazy(() => import("@/pages/Service"));
const Source = lazy(() => import("@/pages/Source"));
const Store = lazy(() => import("@/pages/Store"));
const StoreCategories = lazy(() => import("@/pages/Store/components/StoreCategories.jsx"));
const TechHelp = lazy(() => import("@/pages/TechHelp/index"));
const Notifications = lazy(() => import("@/pages/Notification"));
const Languages = lazy(() => import("@/pages/Languages"));
const Translation = lazy(() => import("@/pages/Translation"));
const TaskBoard = lazy(() => import("@/pages/TasksBoard"));
const TaskStatistics = lazy(() => import("@/pages/TaskStatistics"));
const History = lazy(() => import("@/pages/History"));
const CashierBackgroundImage = lazy(() => import("@/pages/CashierBackground"));
const Offers = lazy(() => import("@/pages/Offers"));
const Ratings = lazy(() => import("@/pages/Ratings"));
const RatingsEmployeeTasks = lazy(() =>
  import("@/pages/Ratings/EmployeeTasks"),
);

const Logout = lazy(() => import("@/pages/Auth/Logout"));

const adminRoutes = [
  { path: "/", exact: true, component: ScrollTop(Dashboard) },
  { path: "/logout", exact: true, component: ScrollTop(Logout) },

  { path: "/ratings", exact: true, component: ScrollTop(Ratings) },
  {
    path: "/ratings/:id",
    exact: true,
    component: ScrollTop(RatingsEmployeeTasks),
  },

  {
    path: "/dashboard/workers",
    exact: true,
    component: ScrollTop(ListEmployees),
  },
  {
    path: "/dashboard/transactions",
    exact: true,
    component: ScrollTop(TransactionDashboard),
  },
  {
    path: "/dashboard/by-region",
    exact: true,
    component: ScrollTop(ListEmployees),
  },
  {
    path: "/dashboard/sales",
    exact: true,
    component: ScrollTop(SalesDashboard),
  },
  {
    path: "/dashboard/sales/monthly",
    exact: true,
    component: ScrollTop(SalesDashboardMonthly),
  },

  { path: "/accounts", exact: true, component: ScrollTop(Users) },
  { path: "/employees", exact: true, component: ScrollTop(Employees) },
  {
    path: "/employees-on-map",
    exact: true,
    component: ScrollTop(EmployeesOnMap),
  },
  { path: "/profile", exact: true, component: ScrollTop(Profile) },
  { path: "/user-log", exact: true, component: ScrollTop(UserLog) },

  { path: "/organizations", exact: true, component: ScrollTop(Organizations) },
  {
    path: "/organization-services",
    exact: true,
    component: ScrollTop(ServiceOrganization),
  },
  {
    path: "/admin-organizations",
    exact: true,
    component: ScrollTop(OrganizationsFilial),
  },
  { path: "/departments", exact: true, component: ScrollTop(Departments) },
  {
    path: "/organization-status",
    exact: true,
    component: ScrollTop(OrganizationStatus),
  },
  { path: "/offline-jobs", exact: true, component: ScrollTop(OfflineJobs) },
  {
    path: "/counterparties",
    exact: true,
    component: ScrollTop(Counterparties),
  },

  { path: "/transactions", exact: true, component: ScrollTop(Transactions) },
  {
    path: "/transaction-debt",
    exact: true,
    component: ScrollTop(TransactionDebt),
  },
  {
    path: "/transactions-devent",
    exact: true,
    component: ScrollTop(TransactionsDevent),
  },
  {
    path: "/transactions-bank",
    exact: true,
    component: ScrollTop(TransactionHamkorbankList),
  },
  {
    path: "/transactions-hamkorbank",
    exact: true,
    component: ScrollTop(TransactionHamkorbank),
  },
  { path: "/orders", exact: true, component: ScrollTop(OrdersList) },
  { path: "/approvals", exact: true, component: ScrollTop(Approvals) },

  { path: "/storage/comings", exact: true, component: ScrollTop(Comings) },
  {
    path: "/storage/comings/:id",
    exact: true,
    component: ScrollTop(ComingsView),
  },
  {
    path: "/storage/incomes",
    exact: true,
    component: ScrollTop(IncomesReport),
  },
  {
    path: "/storage/incomes/:id",
    exact: true,
    component: ScrollTop(IncomeReportInner),
  },
  {
    path: "/storage/consumption",
    exact: true,
    component: ScrollTop(Consumption),
  },
  {
    path: "/storage/consumption/:id",
    exact: true,
    component: ScrollTop(ConsumptionInner),
  },
  { path: "/storage/transfers", exact: true, component: ScrollTop(Transfer) },
  {
    path: "/storage/transfers/:id",
    exact: true,
    component: ScrollTop(TransferView),
  },
  {
    path: "/storage/adjustments",
    exact: true,
    component: ScrollTop(Adjustments),
  },
  { path: "/storages", exact: true, component: ScrollTop(Warehouse) },
  { path: "/storages/:id", exact: true, component: ScrollTop(InnerWarehouse) },

  { path: "/materials", exact: true, component: ScrollTop(Materials) },
  { path: "/materials/archive", exact: true, component: ScrollTop(Materials) },
  {
    path: "/materials/imports",
    exact: true,
    component: ScrollTop(MaterialsImports),
  },
  { path: "/materialsTwo", exact: true, component: ScrollTop(MaterialsTwo) },
  {
    path: "/materialsTwo/archive",
    exact: true,
    component: ScrollTop(MaterialsTwo),
  },
  {
    path: "/materialsTwo/imports",
    exact: true,
    component: ScrollTop(MaterialsTwoImports),
  },
  { path: "/categories", exact: true, component: ScrollTop(Categories) },
  {
    path: "/categories/import",
    exact: true,
    component: ScrollTop(ImportCategories),
  },

  {
    path: "/transactions/categories/expense",
    exact: true,
    component: ScrollTop(CategoriesExpense),
  },
  {
    path: "/transactions/categories/income",
    exact: true,
    component: ScrollTop(CategoriesIncome),
  },
  {
    path: "/transactions-finance",
    exact: true,
    component: ScrollTop(TransactionsFinance),
  },
  { path: "/cashbox", exact: true, component: ScrollTop(Cashbox) },
  {
    path: "/debt-payment-split",
    exact: true,
    component: ScrollTop(DebtPaymentSplit),
  },
  {
    path: "/finance-templates",
    exact: true,
    component: ScrollTop(FinanceTemplatesList),
  },
  {
    path: "/finance-templates/:id/edit",
    exact: true,
    component: ScrollTop(FinanceTemplateEdit),
  },

  { path: "/payment-types", exact: true, component: ScrollTop(PaymentTypes) },
  {
    path: "/payment-types/import",
    exact: true,
    component: ScrollTop(ImportPaymentTypes),
  },
  { path: "/units", exact: true, component: ScrollTop(Units) },

  {
    path: "/reports/debt-credit",
    exact: true,
    component: ScrollTop(ReportDebtCredit),
  },
  { path: "/reports/act/:id", exact: true, component: ScrollTop(ReportAct) },
  {
    path: "/report/products",
    exact: true,
    component: ScrollTop(ReportProducts),
  },
  {
    path: "/report/products/count",
    exact: true,
    component: ScrollTop(ReportProductsCount),
  },

  { path: "/leads/:type", exact: true, component: ScrollTop(Leads) },
  { path: "/lead-status", exact: true, component: ScrollTop(LeadsStatus) },
  { path: "/lead-tags", exact: true, component: ScrollTop(LeadsTags) },
  {
    path: "/leads-statistics",
    exact: true,
    component: ScrollTop(LeadsStatistics),
  },
  {
    path: "/lead-cancellation",
    exact: true,
    component: ScrollTop(LeadCancellation),
  },

  {
    path: "/handbook/regions",
    exact: true,
    component: ScrollTop(HandbookRegion),
  },
  {
    path: "/handbook/country",
    exact: true,
    component: ScrollTop(HandbookCountry),
  },
  {
    path: "/handbook/districts",
    exact: true,
    component: ScrollTop(HandbookDistrict),
  },
  { path: "/targets", exact: true, component: ScrollTop(Targets) },

  { path: "/service", exact: true, component: ScrollTop(Service) },
  { path: "/source", exact: true, component: ScrollTop(Source) },
  { path: "/store", exact: true, component: ScrollTop(Store) },
  { path: "/store-categories", exact: true, component: ScrollTop(StoreCategories) },
  { path: "/tech-help", exact: true, component: ScrollTop(TechHelp) },
  { path: "/notification", exact: true, component: ScrollTop(Notifications) },
  { path: "/languages", exact: true, component: ScrollTop(Languages) },
  { path: "/translation", exact: true, component: ScrollTop(Translation) },
  { path: "/task-board", exact: true, component: ScrollTop(TaskBoard) },
  {
    path: "/task-statistics",
    exact: true,
    component: ScrollTop(TaskStatistics),
  },
  { path: "/history", exact: true, component: ScrollTop(History) },
  {
    path: "/image-background",
    exact: true,
    component: ScrollTop(CashierBackgroundImage),
  },
  { path: "/offers", exact: true, component: ScrollTop(Offers) },
];

export default adminRoutes;
